export default "__VITE_ASSET__2UhPlGmr__"